/**
 * Enum for coupon discount types
 */
export enum CouponType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage'
}

/**
 * Options for coupon type selection in forms
 */
export const COUPON_TYPE_OPTIONS = [
  { label: 'Fixed ($)', value: CouponType.FIXED },
  { label: 'Percentage (%)', value: CouponType.PERCENTAGE }
]

/**
 * Verified coupon response from the verify endpoint
 * Contains only the fields needed for discount calculation
 */
export interface VerifiedCoupon {
  id: string
  couponCode: string
  type: CouponType
  amount: number
}

export interface Coupon {
  id: string
  couponCode: string
  type: CouponType
  amount: number
  active: boolean
  settings: Record<string, any>
  name: string | null
  startAt: string | null
  endAt: string | null
  maxRedemptions: number | null
  /** Current redemption count (API returns as "redemptions") */
  redemptions: number
  createdByUserId?: string | null
  createdByName?: string | null
  archivedAt: string | null
  inactiveAt: string | null
  insertedAt: string
  updatedAt: string
}

/**
 * Coupon option item from the all coupons endpoint
 * Contains only the coupon code for filter options
 */
export interface CouponOption {
  couponCode: string
}

/**
 * API response structure for the all coupons endpoint
 */
export interface CouponsOptionsResponse {
  data: {
    data: CouponOption[]
  }
}
